// ============================================================
// หน้า UsageHistory — ประวัติค่าใช้จ่าย (ใบเสร็จที่ออกไปแล้วทั้งหมด)
// ------------------------------------------------------------
// สิ่งที่ทำได้
//   - ดูใบเสร็จย้อนหลัง กรองตามบ้านเลขที่ แบ่งหน้า
//   - ยกเลิกใบเสร็จ (ใส่หมายเหตุได้) — ยกเลิกแล้วบิลกลับไปค้างชำระ ต้องคิดยอดของห้องนั้นใหม่
//   - พิมพ์ใบเสร็จซ้ำ
//
// การคิดยอดในตาราง: ช่องที่ s_<ช่อง> = false คือช่องที่ยกเลิกการชำระไปแล้ว แสดงเป็น 0.00
// ============================================================

import React, { Component } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { loading, tokens, select_style, success, toFixed, GET, DELETE, format_date, getStorage, total, calculate_water, permission, Paginate, ActionIcon, ICON, printReceiptByIwNumber } from "../../shared/index.js";

// ค่า source_menu ของใบเสร็จ (ตรงกับ Record_receipt.source_menu ฝั่ง backend)
// หน้านี้โชว์ป้ายที่มาเฉพาะใบที่ออกจากหน้าปรับปรุงใบเสร็จรับเงินเท่านั้น
const SOURCE_RECEIPT_ADJUSTMENT = "receipt-adjustment";


const perm = permission("usage-history");

// สถานะใบเสร็จ 1 = ปกติ (อย่างอื่น = ถูกยกเลิกแล้ว)
const BILL_ACTIVE = 1;

// ช่องค่าใช้จ่ายที่ต้องคิดยอดใหม่จากรายการรับชำระย่อย
//   k  = ฟิลด์บนใบเสร็จ
//   sk = ฟิลด์ "เก็บเงินช่องนี้แล้ว" ในรายการย่อย
const PAID_FIELDS = [
  { k: "water_bill", sk: "s_water_bill" },
  { k: "waste_cost", sk: "s_waste_cost" },
  { k: "reduce_debt", sk: "s_reduce_debt" },
  { k: "other_income", sk: "s_other_income" },
  { k: "meter_connect_cost", sk: "s_meter_connect_cost" },
  { k: "late_payment", sk: "s_late_payment" },
  { k: "fire_cost", sk: "s_fire_cost" },
  { k: "equipment_maintenance_fee", sk: "s_equipment_maintenance_fee" },
  { k: "common_expenses", sk: "s_common_expenses" },
  { k: "cable_cost", sk: "s_cable_cost" },
  { k: "add_debt", sk: "s_add_debt" },
];

export default class UsageHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_delete: false,
      page: 1,
      filter_address_number: null,
      filter_iw_number: "",
      data: null,
      data_address: null,
      // ใบเสร็จที่กำลังจะยกเลิก
      record_receipt_id: "",
      address_number: "",
      delete_remark: "",
    };
  }

  async componentDidMount() {
    if (!perm.view) return;
    loading(true);
    await Promise.all([this.GetAll(), this.GetAddressAll()]);
    loading(false);
  }

  // ---------- โหลดข้อมูล ----------

  GetAddressAll = async () => {
    const result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) {
      this.setState({ data_address: result.data.data.map((item) => ({ value: item.address_number, label: `อาคาร ${item.building} ห้อง ${item.address_number}` })) });
    }
  };

  // ยอดรวมของใบเสร็จ 1 ใบ จากค่าบนตัวใบเอง (ช่องที่ยกเลิกชำระแล้วนับเป็น 0)
  // ใบรายรับอื่นๆ ให้บวกราคาของรายการนั้นเข้าไปด้วย
  billTotalFromFlags = (item) => {
    const val = (key, flagKey) => (item[flagKey] === false ? 0 : item[key] || 0);
    return (
      val("add_debt", "s_add_debt") +
      val("cable_cost", "s_cable_cost") +
      val("common_expenses", "s_common_expenses") +
      val("equipment_maintenance_fee", "s_equipment_maintenance_fee") +
      val("fire_cost", "s_fire_cost") +
      val("late_payment", "s_late_payment") +
      val("meter_connect_cost", "s_meter_connect_cost") +
      val("other_income", "s_other_income") +
      val("waste_cost", "s_waste_cost") +
      val("water_bill", "s_water_bill") -
      val("reduce_debt", "s_reduce_debt") +
      (item.record_other_list?.[0]?.cost || 0)
    );
  };

  // ใบที่มีรายการรับชำระย่อย ให้คิดยอดแต่ละช่องใหม่จากรายการย่อยที่ถูกเก็บเงินจริง
  // ช่องที่ไม่มีรายการย่อยไหนเก็บเลย = 0
  recalcFromTransactions = (item) => {
    PAID_FIELDS.forEach(({ k, sk }) => {
      const paid = item.transaction_payments.filter((p) => p[sk]);
      item[k] = paid.length ? total(paid, k) : 0;
    });

    item.total_amount =
      item.water_bill +
      item.waste_cost +
      item.other_income +
      item.meter_connect_cost +
      item.late_payment +
      item.fire_cost +
      item.equipment_maintenance_fee +
      item.common_expenses +
      item.cable_cost +
      item.add_debt -
      item.reduce_debt;
  };

  GetAll = async () => {
    const result = await GET(tokens, `v1/TH/record-receipt/history/filter-search/page/${this.state.page}/${getStorage("project_id")}`, {
      address_number: this.state.filter_address_number?.value || "",
      iw_number: this.state.filter_iw_number || "",
    });
    if (!result?.status) return;

    const array = result.data;
    array.data.forEach((item) => {
      // ยอดตั้งต้นจากค่าบนใบเสร็จ
      item.total_amount = this.billTotalFromFlags(item);

      if (item.transaction_payments?.length > 0) {
        // มีรายการรับชำระย่อย → คิดยอดใหม่จากรายการย่อย
        this.recalcFromTransactions(item);
      } else {
        // ไม่มีรายการย่อย → ค่าปรับใช้ค่าบนใบเสร็จ (ยกเลิกชำระแล้วเป็น 0)
        item.late_payment = item.s_late_payment ? item.late_payment || 0 : 0;
      }
    });

    this.setState({ data: array });
  };

  // ---------- ยกเลิกใบเสร็จ ----------

  Delete = async () => {
    loading(true);
    const result = await DELETE(tokens, `v1/TH/bill-water-group/delete/${this.state.record_receipt_id}`, { delete_remark: this.state.delete_remark });
    if (result?.status) {
      // ยกเลิกแล้วบิลกลับไปค้างชำระ ต้องคิดยอด/เบี้ยปรับของห้องนั้นใหม่
      if (this.state.address_number) await calculate_water(this.state.address_number);
      this.clear_form();
      success();
      this.GetAll();
    }
    loading(false);
  };

  clear_form = () => this.setState({ modal_delete: false, page: 1, filter_address_number: null, record_receipt_id: "", delete_remark: "" });

  // พิมพ์ใบเสร็จซ้ำ (ใช้สูตรมาตรฐานเดียวกับหน้ารับชำระ — ดู shared/domain/receipt-print.js)
  Print = (iw_number) => {
    this.setState({ delete_remark: "" });
    printReceiptByIwNumber(iw_number, this.clear_form);
  };

  render() {
    const { data, data_address, filter_address_number, filter_iw_number, page, modal_delete, delete_remark } = this.state;

    // ช่องที่ยกเลิกการชำระแล้ว (s_* = false) แสดงเป็น 0.00
    const showVal = (value, flag) => (flag === false ? "0.00" : toFixed(value || 0));

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ประวัติค่าใช้จ่าย" />

        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3">
                  <b>ประวัติค่าใช้จ่าย</b>
                </h4>
              </div>

              {/* ตัวกรอง */}
              {perm.view && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <div className="d-flex row mx-0">
                    <Select
                      className="form-control bg-contain border-0 select-search wpx-200 mb-3 mx-1"
                      styles={select_style}
                      options={data_address || []}
                      onChange={(e) => this.setState({ filter_address_number: e })}
                      value={filter_address_number}
                    />
                    <input
                      type="search"
                      className="form-control wpx-200 bg-contain border-0 mb-3 mx-1"
                      placeholder="ค้นหาด้วยเลขที่ใบเสร็จ (IW)"
                      value={filter_iw_number}
                      onChange={(e) => this.setState({ filter_iw_number: e.target.value })}
                    />
                    <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>
                      ค้นหา
                    </button>
                    <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={() => this.setState({ filter_address_number: null, filter_iw_number: "", page: 1 }, this.GetAll)}>
                      รีเซ็ท
                    </button>
                  </div>
                </div>
              )}

              {/* ตารางใบเสร็จ */}
              <div className="table-responsive">
                <table className="table table-borderless table-striped text-nowrap">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      <th className="text-left">เลขที่ใบเสร็จ</th>
                      <th className="text-left">วันที่ใบเสร็จ</th>
                      <th className="text-left">บ้านเลขที่</th>
                      <th className="text-left">จำนวนหน่วยที่ใช้</th>
                      <th className="text-right">ค่าน้ำประปา</th>
                      <th className="text-right">ค่ารักษาอุปกรณ์น้ำ</th>
                      <th className="text-right">ค่าส่วนกลาง</th>
                      <th className="text-right">ค่าขยะ</th>
                      <th className="text-right">ค่าเคเบิล</th>
                      <th className="text-right">ค่าเบี้ยประกัน</th>
                      <th className="text-right">รายการอื่นๆ</th>
                      <th className="text-right">เพิ่ม/ลดหนี้</th>
                      <th className="text-right">ค่าปรับล่าช้า</th>
                      <th className="text-right">ปรับปรุงยอดเงิน</th>
                      <th className="text-right">รวมเป็นเงิน</th>
                      {perm.delete && <th className="text-center">ยกเลิกรายการ</th>}
                      <th className="text-center">พิมพ์ใบเสร็จ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!data?.data?.length ? (
                      <tr>
                        <td colSpan={16} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      data.data.map((item, index) => {
                        // เพิ่ม/ลดหนี้ รวมยอดที่ปรับตอนรับชำระ (add_on_*) ด้วย
                        const addDebt = item.s_add_debt === false ? 0 : (item.add_debt || 0) + (item.add_on_add_debt || 0);
                        const reduceDebt = item.s_reduce_debt === false ? 0 : (item.reduce_debt || 0) + (item.add_on_reduce_debt || 0);
                        // ใบรายรับอื่นๆ ให้แสดงราคาจากรายการนั้นแทนช่องรายได้อื่น
                        const otherCost = item.record_other_list?.[0]?.cost;

                        return (
                          <tr key={index}>
                            <td>
                              {item.iw_number || "-"}
                              {item.source_menu === SOURCE_RECEIPT_ADJUSTMENT && (
                                <span className="src-tag" title="ปรับปรุงใบเสร็จรับเงิน">
                                  &#9432;
                                  <span className="src-tag__pop">ที่มา: ปรับปรุงใบเสร็จรับเงิน</span>
                                </span>
                              )}
                            </td>
                            <td>{item.record_date ? format_date(item.record_date, "dd/mm/yyyy") : "-"}</td>
                            <td className="text-right">{item.address_number || item.address || "-"}</td>
                            <td className="text-right">{item.sum_unit_used || "0"}</td>
                            <td className="text-right">{showVal(item.water_bill, item.s_water_bill)}</td>
                            <td className="text-right">{showVal(item.equipment_maintenance_fee, item.s_equipment_maintenance_fee)}</td>
                            <td className="text-right">{showVal(item.common_expenses, item.s_common_expenses)}</td>
                            <td className="text-right">{showVal(item.waste_cost, item.s_waste_cost)}</td>
                            <td className="text-right">{showVal(item.cable_cost, item.s_cable_cost)}</td>
                            <td className="text-right">{showVal(item.fire_cost, item.s_fire_cost)}</td>
                            <td className="text-right">{otherCost !== undefined ? toFixed(otherCost) : showVal(item.other_income, item.s_other_income)}</td>
                            <td className="text-right">{toFixed(addDebt - reduceDebt)}</td>
                            <td className="text-right">{toFixed(item.late_payment || 0)}</td>
                            <td className="text-right">{toFixed(item.change_satang || 0)}</td>
                            <td className="text-right">{toFixed(item.record_other_list?.[0]?.cost && !item.total_final ? item.record_other_list[0].cost : item.total_final || item.total_amount)}</td>

                            {perm.delete && (
                              <td className="text-center">
                                {item.status_bill === BILL_ACTIVE ? (
                                  <ActionIcon
                                    color="danger"
                                    icon={ICON.delete}
                                    title="ยกเลิกใบเสร็จ"
                                    className="mx-auto mb-0"
                                    onClick={() => this.setState({ modal_delete: true, record_receipt_id: item.record_receipt_id, address_number: item.address_number })}
                                  />
                                ) : (
                                  <label className="text-danger">ยกเลิกแล้ว</label>
                                )}
                              </td>
                            )}

                            <td className="text-center">{item.status_bill === BILL_ACTIVE && <ActionIcon color="primary" icon={ICON.print} title="พิมพ์ใบเสร็จ" className="mx-auto mb-0" onClick={() => this.Print(item.iw_number)} />}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

              <Paginate data={data} page={page} onChange={(value) => this.setState({ page: value }, this.GetAll)} />
            </div>
          </div>
        </div>

        {/* popup ยืนยันยกเลิกใบเสร็จ */}
        <Modal show={modal_delete} onHide={() => this.setState({ modal_delete: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>ยืนยันการลบประวัติค่าใช้จ่าย</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex mb-3">
              <label>ท่านแน่ใจว่าต้องการลบข้อมูลลูกค้า หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label>
            </div>
            <input className="form-control border-0 bg-contain mb-3" type="text" placeholder="หมายเหตุยกเลิก (ถ้ามี)" value={delete_remark} onChange={(e) => this.setState({ delete_remark: e.target.value })} />
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_delete: false })}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-danger w-100" onClick={this.Delete}>
                  ยืนยัน
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
